import type { SVGProps } from "react";
import * as React from "react";

const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 19H0zM3 6V5zm4 0v1a1 1 0 0 0 .832-.445zm2-3V2a1 1 0 0 0-.832.445zm6 0 .832-.555A1 1 0 0 0 15 2zm2 3-.832.555A1 1 0 0 0 17 7zm4 0V5zm1 13a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 24 19zm-.293.707A1 1 0 0 1 21 20v2a3 3 0 0 0 2.121-.879zM21 20H3v2h18zM3 20a1 1 0 0 1-.707-.293L.879 21.121A3 3 0 0 0 3 22zm-.707-.293A1 1 0 0 1 2 19H0a3 3 0 0 0 .879 2.121zM2 19V8H0v11zM2 8a1 1 0 0 1 .293-.707L.879 5.879A3 3 0 0 0 0 8zm.293-.707A1 1 0 0 1 3 7V5a3 3 0 0 0-2.121.879zM3 7h4V5H3zm4.832-.445 2-3-1.664-1.11-2 3zM9 4h6V2H9zm5.168-.445 2 3 1.664-1.11-2-3zM17 7h4V5h-4zm4 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 21 5zm.707.293A1 1 0 0 1 22 8h2a3 3 0 0 0-.879-2.121zM22 8v11h2V8zm-7 5a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V8a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5z"
    />
  </svg>
);
export default SvgCamera;
